var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 38.488,
  height: 36.552,
  viewBox: "0 0 38.488 36.552"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.428,
  y1: 0.453,
  x2: 0.964,
  y2: 1.11,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3147c1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2474b9"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Path_644",
  "data-name": "Path 644",
  d: "M27.565,17.512,19.556,5.042,11.6,17.512H.42L14.073-1.248,1.119-19.04H12.461L19.61-7.214l7.1-11.826H37.886L24.985-1.409,38.907,17.512Z",
  transform: "translate(-0.42 19.04)",
  fill: "url(#linear-gradient)"
})));
export default __webpack_public_path__ + "static/media/CheckOutXLogo.5f1c0ae3.svg";
export { SvgComponent as ReactComponent };